<template>
    <div>
        <div id="notfound">
                <div class="notfound">
                    <div>
                        <div class="notfound-404">
                            <h1>!</h1>
                        </div>
                        <h2> ŞİFRENİZİ DEĞİŞTİRİN</h2>
                    </div>
                    <p style="font-size: 18px; width:100%; font-weight: bold;">  
                        Sistem tarafından oluşturulan varsayılan şifreyi kullanmaktasınız. Güvenliğiniz için bu şifreyi 
                        değiştirmeniz gerekmektedir. İşlemlerinize devam edebilmek için lütfen şifrenizi değiştirin ve yeniden
                        giriş yapın. Kendinize özel bir şifre oluşturun ve lütfen bu şifreyi kimseyle paylaşmayınız.
                    </p>
                    <Form ref="changePass" :loading="loading" :forms="ChangePassForm"/>
                    <b-button variant="primary" @click="saveForm">{{$t('general.save')}}</b-button>

                </div>
                
            </div>
            <div style="margin:0 5rem">
                
        
            </div>
           
    </div>
</template>

<script>
    import BreadCrumb from '@/components/BreadCrumb'
    import i18n from '@/plugins/i18n';
    import jwt_decode from "jwt-decode";
    import Form from '@/components/Form'
    import Forms from './forms'
    import {prepareRequestData, setFormData} from '@/assets/js/custom.js'

    let breadCrumb = [
        { label: i18n.t('pages.user.users'), url: "/User/List" },
        { label: i18n.t('pages.user.changePw'), url: "/User/Change" },
    ]
    export default {
        name: 'Change',
        data: function(){
            return{
                breadCrumb,
                ChangePassForm: Forms.ChangeDefault,

            }
        },
        components:{
            BreadCrumb, Form
        },
        computed:{
            loading(){
                return this.$store.getters.getUserLoading
            }
        },
        methods:{
           
            saveForm: function(){
                this.$refs.changePass.$refs.Form.validate().then( async success =>{
                    if(success){
                        let data = prepareRequestData(this.ChangePassForm, this.$refs.changePass.formData)
                        data.user_id = jwt_decode(localStorage.getItem('access_token')).user_id,
                        await this.$store.dispatch('changeDefaultPassword', data)
                        if(this.$store.getters.getUserStatus.status == "Success"){
                            localStorage.removeItem('access_token')
                            localStorage.removeItem('refresh_token')
                            location.reload();
                        }
                    }
                })  
            }
        }
    }
</script>
<style lang="css" scoped> 
    @import "./styles/error.min.css"; 
</style>


// WEBPACK FOOTER //
// src/pages/General/Users/ChangeDefault.vue